"use client"

import type { I18nLocale } from "@/modules/i18n/types"
import type { ComponentProps, FunctionComponent } from "react"

import { Search } from "@jobteaser/spark/components/Icons/Search"

import { TrackObfuscatedLink } from "@/modules/tracking/components/TrackObfuscatedLink"
import { ensureTrackingProps } from "@/modules/tracking/helpers/ensureTrackingProps"

type ShowJobOffersLinkProps = Omit<ComponentProps<typeof TrackObfuscatedLink>, "trackingProps"> & {
  locale: I18nLocale
  trackingRefIds: Record<string, string[]>
  trackingRole: string
  trackingSchoolId: string
  trackingVisualContext: string
  useIcon?: boolean
}

export const ShowJobOffersLink: FunctionComponent<ShowJobOffersLinkProps> = ({
  children,
  locale,
  trackingRefIds,
  trackingRole,
  trackingSchoolId,
  trackingVisualContext,
  variant = "highlight",
  useIcon = false,
  ...props
}) => {
  const { href } = props

  return (
    <TrackObfuscatedLink
      {...props}
      icon={useIcon ? Search : undefined}
      trackingProps={ensureTrackingProps({
        eventName: "event_click",
        eventProperties: {
          clicked_url: href,
          ref_ids: trackingRefIds,
          role: `${trackingRole}-job-ad-filter`,
          service: "generic_fe",
          trackee_locale: locale,
          trackee_school_id: trackingSchoolId,
          visual_context: `${trackingVisualContext}-section-showall-button`,
        },
      })}
      variant={variant}
    >
      {children}
    </TrackObfuscatedLink>
  )
}
